import { configureStore } from "@reduxjs/toolkit";
import userProfilesReducer from "./slices/UserProfilesSlice";
import preRegisterDetailsReducer from "./slices/PreregisterDetailsSlice";
import participantsDetailsReducer from "./slices/ParticipantsDetailsSlice";
import homeSearchSliceReducer from "./slices/homeSearchSlice";
import alarmsSearchSliceReducer from "./slices/alarmsSearchSlice";
import recipientsSearchReducer from "./slices/recipientsSearchSlice";
import sendersSearchReducer from "./slices/sendersSearchSlice";
import materialRequestHistoryReducer from "./slices/materialRequestHistorySlice";

export default configureStore({
  reducer: {
    userProfiles: userProfilesReducer,
    preRegisterDetails: preRegisterDetailsReducer,
    participantsDetails: participantsDetailsReducer,
    homeSearch: homeSearchSliceReducer,
    alarmsSearch: alarmsSearchSliceReducer,
    recipientsSearch: recipientsSearchReducer,
    sendersSearch: sendersSearchReducer,
    materialRequestHistory: materialRequestHistoryReducer,
  },
});
